<template>
    <div class="basePage homePageView">
        <div class="homePageViewTop">
            <div class="homePageViewTopLeft " @click="jumpPage('/userEdit')">
                <div class="homePageViewTopLeftIn line-limit-length">
                    {{ userName }}
                </div>
                <div class="homePageViewTopLeftVip">
                    <img class="homePageViewTopLeftIsVip" src="../assets/images/VIP.png" v-if="isVip == 0" alt="">
                    <img class="homePageViewTopLeftIsVip" src="../assets/images/VIPHighlight.png" v-else-if="isVip == 1"
                        alt="">
                </div>
            </div>
            <div class="homePageViewTopRight">
                <div class="homePageViewTopRightDate" @click="openCalendar">
                    <van-icon name="arrow-left" size="0.64rem" class="homePageViewTopRightArrow" />
                    <img class="homePageViewTopRightImg" src="../assets/images/newHome/rili.png" alt="">
                    <span class="homePageViewTopText">{{ calendarTime }}</span>
                    <van-icon name="arrow" size="0.64rem" class="homePageViewTopRightArrow2" />
                </div>
                <div class="homePageViewTopRightMsg" @click="goNotice">
                    <van-icon name="chat-o" :dot="hasUnread" />
                </div>
            </div>
        </div>
        <van-swipe class="homePageViewSwipe" :autoplay="3000" indicator-color="#6F8FEA">
            <van-swipe-item class="homePageViewSwipeOne">
                <div class="homePageViewLab" @click="goLaboratory">
                    <div class="homePageViewLabText homePageViewTitle">跑姿秀场</div>
                    <div class="homePageViewLabGo homePageViewLabGoPos">
                        <span>今天，等你来秀</span>
                        <img class="homePageViewLabGoIcon" src="../assets/images/newHome/labjiantou.png" alt="">
                    </div>
                </div>
            </van-swipe-item>
            <van-swipe-item class="homePageViewSwipeOne" v-if="activityList != null">
                <div class="homePageViewLab2" @click="jumpMovingTrail">
                    <div class="homePageViewLabText homePageViewTitle">限时活动</div>
                    <div class="homePageViewLabGo homePageViewLabGoPos">
                        <span>3公里打卡</span>
                        <img class="homePageViewLabGoIcon" src="../assets/images/newHome/labjiantou.png" alt="">
                    </div>
                </div>
            </van-swipe-item>
        </van-swipe>
        <div class="homePageViewFeature">
            <div class="homePageViewFeatureOne" @click="jumpPage('/historicalFile')">
                <div class="homePageViewFeatureTitle">跑姿典藏</div>
                <div class="homePageViewFeatureIntroduce">记录每一步，见<br />证成长尽在掌握</div>
            </div>
            <div class="homePageViewFeatureOne" @click="jumpPage('/groupDetail')">
                <div class="homePageViewFeatureTitle">江湖部落</div>
                <div class="homePageViewFeatureIntroduce" style="width: 4.65rem;text-align: left;right: 0;">
                    跑团文化<br />发现周边跑团</div>
            </div>
            <div class="homePageViewFeatureOne" @click="jumpRankingPage(0)">
                <div class="homePageViewFeatureTitle">跑力金榜</div>
                <div class="homePageViewFeatureIntroduce">挑战极限，奔向<br />未来—超越自我</div>
            </div>
        </div>
        <div class="homePageRunPower">
            <div class="homePageViewTitle"> {{ runPowerAcLabel }}跑力值</div>
            <div class="homePageRunPowerChange">
                <div :class="{ 'homePageRunPowerChangeAc': runPowerAc == item.value }" v-for="item in runPowerList"
                    :key="item.value" @click="runPowerTab(item)">
                    {{ item.label }}
                </div>
            </div>
        </div>
        <div class="homePageRunPowerTime">
            <van-icon name="clock-o" color="#9797A8" size="0.57rem" />
            <span>&ensp;{{ engLabel }} {{ timeLabel }}</span>
        </div>
        <div class="homePageRunPowerMsg">
            <div class="homePageRunPowerMsgIn" v-if="runScores != null && bestScores != null">
                <div class="homePageRunPowerMsgEcharts">
                    <echartsRadar :initData="{ echartData: runScores }"></echartsRadar>
                </div>
                <div class="homePageRunPowerMsgLine"></div>
                <div class="homePageRunPowerMsgHot">
                    <img class="homePageRunPowerMsgHotImg" src="../assets/images/newHome/huoyan.png" alt="">
                    <div class="homePageRunPowerMsgHotText">今日跑力分值</div>
                </div>
                <div class="homePageRunPowerCore">
                    <div class="homePageRunPowerCoreOne" style="margin-top: 1.79rem;">
                        <div class="homePageRunPowerCoreOneTitle">本次测试</div>
                        <div class="homePageRunPowerCoreOneTitle">历史最佳</div>
                    </div>
                    <div style="width: 100%;height: 0.27rem;"></div>
                    <div class="homePageRunPowerCoreOne">
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder"
                            :class="runScoresCss.elbow_status">
                            <span class="homePageRunPowerCoreOneFen">{{ runScores.elbow_status }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneCenterText">肘部角度</div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder2"
                            :class="bestScoresCss.elbow_status">
                            <span class="homePageRunPowerCoreOneFen">{{ bestScores.elbow_status }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                    </div>
                    <div class="homePageRunPowerCoreOne">
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder"
                            :class="runScoresCss.swinging_arm_status">
                            <span class="homePageRunPowerCoreOneFen">{{ runScores.swinging_arm_status }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneCenterText">摆臂幅度</div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder2"
                            :class="bestScoresCss.swinging_arm_status">
                            <span class="homePageRunPowerCoreOneFen">{{ bestScores.swinging_arm_status }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                    </div>
                    <div class="homePageRunPowerCoreOne">
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder"
                            :class="runScoresCss.push_off_stage">
                            <span class="homePageRunPowerCoreOneFen">{{ runScores.push_off_stage }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneCenterText">蹬伸摆动</div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder2"
                            :class="bestScoresCss.push_off_stage">
                            <span class="homePageRunPowerCoreOneFen">{{ bestScores.push_off_stage }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                    </div>
                    <div class="homePageRunPowerCoreOne">
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder"
                            :class="runScoresCss.initial_concat_stage">
                            <span class="homePageRunPowerCoreOneFen">{{ runScores.initial_concat_stage }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneCenterText">脚落地</div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder2"
                            :class="bestScoresCss.initial_concat_stage">
                            <span class="homePageRunPowerCoreOneFen">{{ bestScores.initial_concat_stage }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                    </div>
                    <div class="homePageRunPowerCoreOne">
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder"
                            :class="runScoresCss.midstance_stage">
                            <span class="homePageRunPowerCoreOneFen">{{ runScores.midstance_stage }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneCenterText">脚提起</div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder2"
                            :class="bestScoresCss.midstance_stage">
                            <span class="homePageRunPowerCoreOneFen">{{ bestScores.midstance_stage }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                    </div>
                    <div class="homePageRunPowerCoreOne">
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder"
                            :class="runScoresCss.no_elbow_forward_no_hand_backward_principle">
                            <span class="homePageRunPowerCoreOneFen">{{
                                runScores.no_elbow_forward_no_hand_backward_principle }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneCenterText">摆臂偏移量</div>
                        <div class="homePageRunPowerCoreOneLine"></div>
                        <div class="homePageRunPowerCoreOneLabel homePageRunPowerCoreOneLabelBorder2"
                            :class="bestScoresCss.no_elbow_forward_no_hand_backward_principle">
                            <span class="homePageRunPowerCoreOneFen">{{
                                bestScores.no_elbow_forward_no_hand_backward_principle }}</span>
                            <span class="homePageRunPowerCoreOneDanWei">分</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="homePageRunPowerMsgIn" v-else>
                <div class="homePageNoData" @click="jumpPage('/uploadVideos2')">
                    <img class="homePageNoDataImg" src="../assets/images/newHome/noData.png" alt="">
                    <div class="homePageViewLabGo homePageNoDataPos" style="width: 100%;">
                        <span>本日暂无数据. 前去检测</span>
                        <img class="homePageViewLabGoIcon" src="../assets/images/newHome/labjiantou.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="homePageRunPowerRest">
            <img class="homePageRunPowerRestImg" src="../assets/images/newHome/shuibei.png" alt="">
            <div class="homePageRunPowerRestText">休息一下，补充水分，继续加油！</div>
        </div>
        <div class="homePageRanking">
            <div class="homePageViewTitle">我的排名</div>
        </div>
        <div class="homePageRankingNum">
            <div class="homePageRankingNumOne" @click="jumpRankingPage(1)">
                <div class="homePageRankingNumTitle">全国排名</div>
                <div class="homePageRankingNumBg homePageRankingNumBgColor">
                    <template v-if="allRanking">
                        <span class="homePageRankingNumBgText"
                            :class="allRanking > 999 ? 'homePageRankingNumBgTextSmall' : ''">{{ allRanking }} </span>
                        <span class="homePageRankingNumBgText2"
                            :class="allRanking > 999 ? 'homePageRankingNumBgText2Small' : ''">名</span>
                    </template>
                    <template v-else>
                        <span class="homePageRankingNumBgText2" style="padding-top: 0;">暂无排名</span>
                    </template>
                </div>
            </div>
            <div class="homePageRankingNumOne" @click="jumpRankingPage(2)">
                <div class="homePageRankingNumTitle">跑团排名</div>
                <div class="homePageRankingNumBg homePageRankingNumBgColor2">
                    <template v-if="allGroupRanking">
                        <span class="homePageRankingNumBgText"
                            :class="allGroupRanking > 999 ? 'homePageRankingNumBgTextSmall' : ''">{{ allGroupRanking }}
                        </span>
                        <span class="homePageRankingNumBgText2"
                            :class="allGroupRanking > 999 ? 'homePageRankingNumBgText2Small' : ''">名</span>
                    </template>
                    <template v-else>
                        <span class="homePageRankingNumBgText2" style="padding-top: 0;">暂无排名</span>
                    </template>
                </div>
            </div>
        </div>
        <div class="homePageAddVip">
            <div class="homePageAddVipTop">
                <img class="homePageAddVipImg" src="../assets/images/newHome/benpao.png" alt="">
                <div class="homePageAddVipText">You're doing great!</div>
                <div class="homePageAddVipText2">坚持下去,<br />坚持你的计划！</div>
                <div class="homePageAddVipAddButton" @click="jumpPage('/vipBuy')">
                </div>
            </div>
        </div>
        <div class="homePageAddBottom" @click="jumpPage('/vipBuy')">
            <img class="homePageAddBottomImg" src="../assets/images/newHome/VIPText.png" alt="">
        </div>
        <publicCalendar :initShow="calendarShow" @onConfirm="calendarSelOne"></publicCalendar>
        <!-- <div class="homeMaskLayer" v-if="maskLayerShow">
            <div id="homeMaskLayerModel" class="homeMaskLayerIcon"></div>
            <!~~ <svg t="1741243121488" class="icon homeMaskLayerIcon flip-element flipping" viewBox="0 0 1024 1024"
                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="14364" width="86" height="86">
                <path
                    d="M333.312 324.608c15.36 0 27.648 12.288 27.648 27.136 0 15.36-12.288 28.16-27.648 28.16H234.496c-14.848 0-27.136-12.8-27.136-28.16s11.776-27.136 27.136-27.136h98.816zM653.312 379.904c-15.872 0-27.648-12.8-27.648-28.16s11.776-27.136 27.648-27.136h98.304c15.872 0 27.648 12.288 27.648 27.136 0 15.36-11.776 28.16-27.648 28.16h-98.304zM520.192 192.512c0 14.848-11.776 27.136-27.648 27.136-14.848 0-27.136-11.776-27.136-27.136V93.696c0-14.848 12.288-27.136 27.136-27.136 15.872 0 27.648 12.288 27.648 27.136v98.816zM625.664 258.56c-10.752 10.752-28.16 10.752-38.912 0-10.752-11.264-10.752-28.16 0-38.912l69.632-70.144c10.752-10.752 28.16-10.752 38.912 0 10.752 11.264 10.752 28.16 0 38.912l-69.632 70.144zM399.872 219.648c10.24 10.752 10.24 28.16 0 38.912-11.264 10.752-28.672 10.752-38.912 0L291.328 188.928c-11.264-10.752-11.264-28.16 0-38.912 10.24-10.752 27.648-10.752 38.912 0l69.632 69.632zM871.936 615.424c-5.632-28.16-31.744-50.688-58.368-50.688-17.408 0-31.744 8.192-40.96 19.456V578.56c0-33.792-26.112-58.88-55.296-58.88s-55.296 28.16-55.296 58.88v-30.72c0-33.792-26.112-58.88-55.296-58.88s-55.296 28.16-55.296 58.88V353.792c0-33.792-26.112-58.88-55.296-58.88-29.184 0-52.224 28.16-52.224 58.88v343.04c0 16.896-11.776 30.72-29.184 30.72h-8.704l-78.848-33.792c-8.704-5.632-17.408-2.56-26.112-5.632-29.184-8.192-55.296 28.16-55.296 58.88 0 19.456 23.04 45.056 34.816 56.32l212.48 210.944H819.2c8.704-39.424 40.96-188.416 52.224-281.088 3.584-45.056 6.656-87.04 0.512-117.76z"
                    p-id="14365" fill="#fff"></path>
            </svg> ~~>
        </div>-->
        <!-- 测试推送 -->
    </div>
</template>

<script>
import echartsRadar from '../components/echartsRadar2.vue'
import dayjs from 'dayjs';
import { utilsReturnEngDate, utilsJudgmentVIP } from '../utils/utils.js'
import { businessGet, businessPost } from '../api/business.js'
import publicCalendar from '../components/publicCalendar.vue'
import Global from '@/Global.js';
import * as THREE from 'three'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import * as TWEEN from 'tween.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
export default {
    name: "homePageView",
    components: {
        echartsRadar,
        publicCalendar
    },
    data() {
        return {
            userInfo: null,
            userName: '',
            runPowerList: [
                {
                    value: 1,
                    label: '今日',
                    engLabel: 'Today',
                },
                {
                    value: 2,
                    label: '昨日',
                    engLabel: 'Yesterday',
                },
                {
                    value: 3,
                    label: '前日',
                    engLabel: 'The day before yesterday',
                },
            ],
            runPowerAc: 1,
            runPowerAcLabel: '今日',
            engLabel: 'Today',
            timeLabel: '',
            radarData: {
                elbow_status: 0,
                initial_concat_stage: 82.5,
                midstance_stage: 76.315,
                no_elbow_forward_no_hand_backward_principle: 33.92,
                push_off_stage: 50,
                swinging_arm_status: 87.5,
            },
            calendarTime: '',
            calendarShow: null,
            runScores: null,
            bestScores: null,
            runScoresCss: null,
            bestScoresCss: null,
            scoreSection: Global.GlobalScoreSection,
            allRanking: '',
            allGroupRanking: '',
            isVip: null,
            maskLayerShow: true,
            activityList: null,
            groupList: [],
            hasUnread: false,
        }
    },
    mounted() {
        this.getLocalUser();
        let Today = dayjs().format('YYYY-MM-DD');
        this.calendarTime = utilsReturnEngDate(Today)
        this.getRunPowerBestData();
        this.getRunPowerData();
        this.getMyRanking();
        console.log('是不是VIP', utilsJudgmentVIP())
        this.isVip = utilsJudgmentVIP();
        this.checkUnreadMsg();
    },
    methods: {
        goNotice() {
            window.wx.miniProgram.navigateTo({
                url: '../reviewList/reviewList'
            })
        },
        checkUnreadMsg() {
            let url = '/system/message/unread-count';
            businessGet(url).then(res => {
                if (res.code == 200) {
                    this.hasUnread = res.data > 0;
                }
            }).catch(() => { });
        },
        jumpMovingTrail() {
            window.wx.miniProgram.navigateTo({
                url: '../movingTrail/movingTrail'
            })
        },
        loadModel2() {
            let that = this;
            that.modelElement = document.getElementById('homeMaskLayerModel');

            that.scene = new THREE.Scene();
            that.clock = new THREE.Clock();

            // 红色的线代表的是X轴，绿色的线为Y轴，蓝色的线为z轴
            // const axesHelper = new THREE.AxesHelper(100)
            // that.scene.add(axesHelper)

            const width = that.modelElement.clientWidth
            const height = that.modelElement.clientHeight
            const k = width / height
            that.camera = new THREE.PerspectiveCamera(35, k, 0.1, 1000);
            that.initialPosition = new THREE.Vector3(280, 400, 250);
            that.camera.position.copy(that.initialPosition); // 设置相机位置
            that.initialLookAt = new THREE.Vector3(0, 0, 0)
            that.camera.lookAt(that.initialLookAt) // 设置相机方向
            that.scene.add(that.camera)

            that.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
            that.renderer.setClearColor(0x000000, 0);
            that.renderer.setSize(width, height)
            that.renderer.shadowMap.enabled = false
            that.renderer.shadowMap.type = THREE.PCFSoftShadowMap
            that.modelElement.appendChild(that.renderer.domElement)

            const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 5);
            hemiLight.position.set(0, 200, 0);
            that.scene.add(hemiLight);

            const dirLight = new THREE.DirectionalLight(0xffffff, 5);
            dirLight.position.set(0, 200, 100);
            dirLight.castShadow = true;
            dirLight.shadow.camera.top = 180;
            dirLight.shadow.camera.bottom = - 100;
            dirLight.shadow.camera.left = - 120;
            dirLight.shadow.camera.right = 120;
            that.scene.add(dirLight);

            const fbxLoader = new GLTFLoader()
            let url = './file/fbx/shouzhi.glb';
            fbxLoader.load(url, fbxMsg => {
                console.log('引导模型信息', fbxMsg)
                if (fbxMsg) {
                    that.fbxMsg = fbxMsg;
                    that.scene.add(fbxMsg.scene);
                    that.mixer = new THREE.AnimationMixer(that.fbxMsg);
                    animate()
                    setTimeout(() => {
                        that.actionPlay();
                    }, 2500)
                }
            })

            function animate() {
                requestAnimationFrame(animate);
                that.mixer.update(that.clock.getDelta());
                TWEEN.update();
                if (that.fbxMsg) {
                    // 这里可以添加动画逻辑，例如旋转模型
                    // that.fbxMsg.rotation.x += 0.01;
                    // that.fbxMsg.rotation.y += 0.01;
                    // that.fbxMsg.rotation.z += 0.02;
                }
                that.renderer.render(that.scene, that.camera);
            }
        },
        actionPlay() {
            this.action = this.mixer.clipAction(this.fbxMsg.animations[0]);
            this.action.loop = THREE.LoopRepeat;
            this.action.repetitions = 2;
            this.action.timeScale = 1;
            this.action.play();
        },
        loadModel() {
            let that = this;
            that.modelElement = document.getElementById('homeMaskLayerModel');

            that.scene = new THREE.Scene();
            that.clock = new THREE.Clock();

            // 红色的线代表的是X轴，绿色的线为Y轴，蓝色的线为z轴
            // const axesHelper = new THREE.AxesHelper(100)
            // that.scene.add(axesHelper)

            const width = that.modelElement.clientWidth
            const height = that.modelElement.clientHeight
            const k = width / height
            that.camera = new THREE.PerspectiveCamera(35, k, 0.1, 1000);
            that.initialPosition = new THREE.Vector3(280, 400, 250);
            that.camera.position.copy(that.initialPosition); // 设置相机位置
            that.initialLookAt = new THREE.Vector3(0, 0, 0)
            that.camera.lookAt(that.initialLookAt) // 设置相机方向
            that.scene.add(that.camera)

            that.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
            that.renderer.setClearColor(0x000000, 0);
            that.renderer.setSize(width, height)
            that.renderer.shadowMap.enabled = false
            that.renderer.shadowMap.type = THREE.PCFSoftShadowMap
            that.modelElement.appendChild(that.renderer.domElement)

            const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 5);
            hemiLight.position.set(0, 200, 0);
            that.scene.add(hemiLight);

            const dirLight = new THREE.DirectionalLight(0xffffff, 5);
            dirLight.position.set(0, 200, 100);
            dirLight.castShadow = true;
            dirLight.shadow.camera.top = 180;
            dirLight.shadow.camera.bottom = - 100;
            dirLight.shadow.camera.left = - 120;
            dirLight.shadow.camera.right = 120;
            that.scene.add(dirLight);

            const fbxLoader = new FBXLoader()
            let url = './file/fbx/手指带动画.fbx';
            fbxLoader.load(url, fbxMsg => {
                console.log('引导模型信息', fbxMsg)
                if (fbxMsg) {
                    that.fbxMsg = fbxMsg;
                    that.scene.add(fbxMsg);
                    that.mixer = new THREE.AnimationMixer(that.fbxMsg);
                    animate()
                    setTimeout(() => {
                        that.actionPlay();
                    }, 2500)
                }
            })

            function animate() {
                requestAnimationFrame(animate);
                that.mixer.update(that.clock.getDelta());
                TWEEN.update();
                if (that.fbxMsg) {
                    // 这里可以添加动画逻辑，例如旋转模型
                    // that.fbxMsg.rotation.x += 0.01;
                    // that.fbxMsg.rotation.y += 0.01;
                    // that.fbxMsg.rotation.z += 0.02;
                }
                that.renderer.render(that.scene, that.camera);
            }


            // // 控件
            // that.controls = new OrbitControls(that.camera, that.renderer.domElement);
            // modelRender();
            // function modelRender() {
            //     that.renderer.render(that.scene, that.camera);
            //     requestAnimationFrame(modelRender);
            // }
            // setTimeout(() => {
            //     this.mixer = new THREE.AnimationMixer(this.fbxMsg);
            //     this.animationDuration = this.fbxMsg.animations[0].duration / this.playSpeed;
            //     this.newMixerTime = this.mixer.time + this.animationDuration;
            //     this.animationQuarterTime = this.mixer.time + this.animationDuration * 0.25
            //     this.action = this.mixer.clipAction(this.fbxMsg.animations[0]);
            //     this.action.loop = THREE.LoopOnce;
            //     this.action.timeScale = this.playSpeed;
            //     this.action.play();
            // }, 500)
        },
        notOpen() {
            this.$toast('暂未开放，敬请期待')
        },
        jumpRankingPage(tab) {
            if (tab == 1) {
                if (this.allRanking == '') {
                    this.$toast('暂无排名')
                    return
                }
            }
            else if (tab == 2) {
                if (this.groupList.length == 0) {
                    this.$toast('暂未加入跑团')
                    return
                }
                if (this.allGroupRanking == '') {
                    this.$toast('暂无排名')
                    return
                }
            }
            this.$router.push('/rankingList2?tab=' + tab)
        },
        convertTime(timeStr) {
            // 分割时间字符串，获取小时、分钟和秒
            const [hours, minutes] = timeStr.split(':');
            // 将小时字符串转换为数字
            let hourNum = parseInt(hours, 10);
            // 判断是上午（AM）还是下午（PM）
            const amPm = hourNum >= 12 ? 'PM' : 'AM';
            // 处理 12 小时制的小时数，若大于 12 则减去 12，若为 0 则设为 12
            hourNum = hourNum % 12 || 12;
            // 拼接最终的时间格式
            this.timeLabel = `${hourNum}:${minutes} ${amPm}`;
        },
        getLocalUser() {
            if (localStorage.getItem(Global.GlobalLocalUserMsg)) {
                this.userInfo = JSON.parse(localStorage.getItem(Global.GlobalLocalUserMsg));
                // console.log(this.userInfo)
                if (this.userInfo.userName) {
                    this.userName = this.userInfo.userName;
                }
                if (this.userInfo.avatar) {
                    this.avatar = this.userInfo.avatar;
                }
            }
        },
        getMyRanking() {
            let url = '/system/person/my-personal-result';
            businessPost(url, { id: null }).then(res => {
                if (res.code == 200) {
                    this.allRanking = res.data.scoreNumber;
                }
            })
            let url2 = '/system/group/user-group-list';
            businessGet(url2).then(res => {
                if (res.code == 200) {
                    if (res.data.list.length > 0) {
                        this.groupList = res.data.list;
                        for (let i = 0; i < res.data.list.length; i++) {
                            if (res.data.list[i].activityList != null) {
                                this.activityList = true;
                                break;
                            }
                        }
                        businessPost(url, { id: res.data.list[0].id }).then(res2 => {
                            if (res2.code == 200) {
                                if (res2.data.scoreNumber) {
                                    this.allGroupRanking = res2.data.scoreNumber;
                                }
                            }
                        })
                    }
                }
            })


        },
        getRunPowerBestData() {
            let url = '/system/task/getBestTask';
            businessGet(url).then(res => {
                if (res.code == 200) {
                    if (res.data && res.data.scores != null) {
                        let runScores = {};
                        let runScoresCss = {};
                        let scores = JSON.parse(res.data.scores)
                        for (let k in scores) {
                            if (scores[k] == null) {
                                scores[k] = 0
                            }
                            runScores[k] = (scores[k].toFixed(0)) * 1;
                            if (scores[k] >= this.scoreSection[1]) {
                                runScoresCss[k] = 'homePageRunPowerCoreOneLabelColor'
                            }
                            else if (scores[k] >= 50 && scores[k] < 80) {
                                runScoresCss[k] = 'homePageRunPowerCoreOneLabelColor2'
                            }
                            else if (scores[k] < 50) {
                                runScoresCss[k] = 'homePageRunPowerCoreOneLabelColor3'
                            }
                        }
                        this.bestScores = runScores;
                        console.log('this.bestScores =', this.bestScores)
                        this.bestScoresCss = runScoresCss;
                        console.log('this.bestScoresCss =', this.bestScoresCss)
                    }
                }
            })
        },
        getRunPowerData() {
            let date = null;
            if (this.runPowerAc == 1) {
                date = dayjs().format('YYYY-MM-DD');
            }
            else if (this.runPowerAc == 2) {
                date = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
            }
            else if (this.runPowerAc == 3) {
                date = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
            }
            let url = '/system/task/getRecentTask?date=' + date;
            businessGet(url).then(res => {
                if (res.code == 200) {
                    if (res.data && res.data.scores != null) {
                        let runScores = {};
                        let runScoresCss = {};
                        let scores = JSON.parse(res.data.scores)
                        for (let k in scores) {
                            if (scores[k] == null) {
                                scores[k] = 0
                            }
                            runScores[k] = (scores[k].toFixed(0)) * 1;
                            if (scores[k] >= this.scoreSection[1]) {
                                runScoresCss[k] = 'homePageRunPowerCoreOneLabelColor'
                            }
                            else if (scores[k] >= 50 && scores[k] < 80) {
                                runScoresCss[k] = 'homePageRunPowerCoreOneLabelColor2'
                            }
                            else if (scores[k] < 50) {
                                runScoresCss[k] = 'homePageRunPowerCoreOneLabelColor3'
                            }
                        }
                        this.runScores = runScores;
                        console.log('this.runScores =', this.runScores)
                        this.runScoresCss = runScoresCss;
                        console.log('this.runScoresCss =', this.runScoresCss)
                        let createTimeList = res.data.createTime.split(' ')
                        this.convertTime(createTimeList[1])
                    }
                }
            })
        },
        jumpPage(url) {
            this.$router.push(url)
        },
        calendarSelOne(val) {
            console.log('子组件返回', val)
            this.jumpPage('/historicalFile?searchTime=' + dayjs(val).format('YYYY-MM-DD'))
        },
        openCalendar() {
            this.calendarShow = { show: true };
        },
        runPowerTab(item) {
            this.runScores = null;
            this.timeLabel = '';
            this.$nextTick(() => {
                this.runPowerAc = item.value;
                this.runPowerAcLabel = item.label;
                this.engLabel = item.engLabel;
                this.getRunPowerData();
            })
        },
        goLaboratory() {
            this.$router.push('/uploadBoot2')
        },
    }
}
</script>

<style scoped>
@import url("../assets/css/base.css");
@import '../assets/css/font.css';

.homePageView {
    overflow-y: auto;
}

.homePageViewTop {
    width: 100%;
    box-sizing: border-box;
    padding: 1.15rem 2rem 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.homePageViewTopLeft {
    width: 9rem;
    display: flex;
    align-items: center;
    position: relative;
}

.homePageViewTopLeftIn {
    display: inline-block;
    font-size: 1.44rem;
    font-weight: 400;
    text-align: left;
    color: #2f2f51;
    line-height: 1;
    letter-spacing: 0.01rem;
}

.homePageViewTopLeftVip {
    width: 1px;
    height: 100%;
    position: relative;
}

.homePageViewTopLeftIsVip {
    width: 1.18rem;
    position: absolute;
    top: -1.3rem;
    right: -0.6rem;
}

.homePageViewTopRight {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    position: relative;
}

.homePageViewTopRightDate {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    line-height: 1;
    vertical-align: bottom;
    margin-right: 0.5rem;
}

.homePageViewTopRightMsg {
    /* line-height: 1;
    display: flex;
    justify-content: center;
    align-items: center; */
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -1.2rem;
}

.homePageViewTopRightImg {
    width: 0.72rem;
    height: 0.72rem;
    margin-right: 0.26rem;
}

.homePageViewTopRightArrow {
    margin-right: 0.5rem;
    margin-top: 0.1rem;
}

.homePageViewTopRightArrow2 {
    margin-left: 0.5rem;
    margin-top: 0.1rem;
}

.homePageViewTopText {
    font-size: 0.72rem;
    font-family: HelveticaNeueLT, HelveticaNeueLT-LightExt;
    font-weight: normal;
    text-align: left;
    color: #2f2f51;
    /* margin-top: 0.1rem; */
}

.homePageViewSwipe {
    width: 100%;
    height: 16rem;
    margin-top: 2.08rem
}

.homePageViewSwipeOne {
    width: 100%;
    height: 100%;
}

/deep/ .van-swipe__indicator {
    background-color: rgba(111, 143, 234, .5);
}

/deep/ .van-swipe__indicators {
    bottom: 2px;
}

.homePageViewLab {
    width: 100%;
    height: 100%;
    background-image: url('../assets/images/newHome/labBg.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    position: relative;
}


.homePageViewLab2 {
    width: 100%;
    height: 100%;
    background-image: url('../assets/images/newHome/labBg2.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    position: relative;
}

.homePageViewTitle {
    font-size: 0.87rem;
    font-family: PangMenZhengDao, PangMenZhengDao-Regular;
    font-weight: 400;
    text-align: left;
    color: #2f2f51;
    line-height: 1;
}

.homePageViewLabText {
    position: absolute;
    top: 0;
    left: 1.18rem;
}

.homePageViewLabGo {
    height: 0.72rem;
    box-sizing: border-box;
    padding-top: 0.05rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-size: 0.72rem;
    font-family: PangMenZhengDao, PangMenZhengDao-Regular;
    font-weight: 400;
    text-align: right;
    color: #6f8fea;
    line-height: 1;
    letter-spacing: 0.04rem;
}

.homePageViewLabGoPos {
    position: absolute;
    top: 0;
    right: 1.54rem;
}

.homePageViewLabGoIcon {
    width: 0.72rem;
    height: 0.51rem;
    object-fit: cover;
    margin-left: 0.46rem;
    margin-top: 0.03rem;
}

.homePageViewFeature {
    width: 100%;
    height: 13.3rem;
    box-sizing: border-box;
    padding: 0 0.2rem;
    display: flex;
    background-image: url('../assets/images/newHome/gongneng.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
}

.homePageViewFeatureOne {
    width: 5.5rem;
    height: 100%;
    position: relative;
    margin: 0 0.46rem;
}

.homePageViewFeatureTitle {
    width: 100%;
    font-size: 0.82rem;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    text-align: center;
    color: #ffffff;
    line-height: 1.13rem;
    position: absolute;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
}

.homePageViewFeatureIntroduce {
    width: 100%;
    opacity: 0.61;
    font-size: 0.62rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Light;
    font-weight: 300;
    text-align: center;
    color: #ffffff;
    line-height: 0.72rem;
    position: absolute;
    bottom: 3.3rem;
    right: 0;
}

.homePageRunPower {
    width: 100%;
    box-sizing: border-box;
    padding: 0 1.21rem;
    display: flex;
    justify-content: space-between;
}

.homePageRunPowerChange {
    width: 6rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.72rem;
    font-family: PangMenZhengDao, PangMenZhengDao-Regular;
    font-weight: 400;
    text-align: left;
    color: #3e3e40;
    line-height: 1.03rem;
}

.homePageRunPowerChangeAc {
    color: #6F8FEA;
}

.homePageRunPowerTime {
    width: 100%;
    box-sizing: border-box;
    margin-top: 0.63rem;
    padding: 0 1.21rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    font-size: 0.56rem;
    font-family: HelveticaNeueLT, HelveticaNeueLT-LightExt;
    font-weight: normal;
    text-align: right;
    color: #9797a8;
    line-height: 0.72rem;
}

.homePageRunPowerMsg {
    width: 100%;
    /* height: 32.69rem; */
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    margin-top: 1.46rem;
}

.homePageRunPowerMsgIn {
    width: 17.64rem;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 2.18rem;
    background: #ffffff;
    border-radius: 0.41rem 3.31rem 0.41rem 0.41rem;
    box-shadow: 0.1rem 0.4rem 1.41rem 0.41rem rgba(111, 143, 234, 0.16);
}

.homePageRunPowerMsgEcharts {
    width: 100%;
    height: 12.67rem;
}

.homePageRunPowerMsgLine {
    width: 16.49rem;
    height: 0.05rem;
    background: #eaeefc;
    border-radius: 0.03rem;
    margin: 0 auto;
}

.homePageRunPowerMsgHot {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.67rem;
}

.homePageRunPowerMsgHotImg {
    width: 0.95rem;
    height: 0.97rem;
    object-fit: cover;
    margin-right: 0.51rem;
}

.homePageRunPowerMsgHotText {
    font-size: 0.87rem;
    font-family: PangMenZhengDao, PangMenZhengDao-Regular;
    font-weight: 400;
    text-align: left;
    color: #2f2f51;
    margin-top: 0.1rem;
}

.homePageRunPowerCore {
    width: 100%;
    box-sizing: border-box;
    padding: 0 2.03rem;
}


.homePageRunPowerCoreOne {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.82rem;
}

.homePageRunPowerCoreOneTitle {
    font-size: 0.72rem;
    font-family: PangMenZhengDao, PangMenZhengDao-Regular;
    font-weight: 400;
    text-align: right;
    color: #2f2f51;
    line-height: 1.03rem;
}

.homePageRunPowerCoreOneLabel {
    width: 4.05rem;
    height: 1.44rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.homePageRunPowerCoreOneLabelColor {
    background: linear-gradient(117.4076deg, #6f8fea 0%, #474ad9 100%);
}

.homePageRunPowerCoreOneLabelColor2 {
    background: linear-gradient(242.592deg, #ccd7ff 0%, #8fa8ff 100%);
}

.homePageRunPowerCoreOneLabelColor3 {
    background: linear-gradient(242.592deg, #ffacc6 0%, #ff4981 100%);
}

.homePageRunPowerCoreOneLabelBorder {
    border-radius: 0.1rem 0.72rem 0.72rem 0.1rem;
}

.homePageRunPowerCoreOneLabelBorder2 {
    border-radius: 0.72rem 0.1rem 0.1rem 0.72rem;
}

.homePageRunPowerCoreOneFen {
    font-size: 0.9rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Light;
    font-weight: bold;
    text-align: left;
    color: #ffffff;
    line-height: 1.13rem;
}

.homePageRunPowerCoreOneDanWei {
    font-size: 0.77rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Light;
    font-weight: bold;
    text-align: left;
    color: #ffffff;
    line-height: 1.13rem;
}

.homePageRunPowerCoreOneLine {
    flex: 0.5;
    height: 0.03rem;
    background-color: #EAEEFC;
}

.homePageRunPowerCoreOneCenterText {
    box-sizing: border-box;
    padding: 0.1rem;
    font-size: 0.62rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Regular;
    font-weight: 400;
    text-align: left;
    color: #2f2f51;
    line-height: 0.85rem;
}

.homePageNoData {
    width: 100%;
    height: 12.18rem;
    position: relative;
}

.homePageNoDataImg {
    width: 10.1rem;
    height: 6.9rem;
    object-fit: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.homePageNoDataPos {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}

.homePageRunPowerRest {
    width: 16.23rem;
    height: 2.69rem;
    background: #e3e9ff;
    border-radius: 0.41rem;
    margin: 1.5rem auto 1.5rem;
    position: relative;
}

.homePageRunPowerRestImg {
    width: 1.77rem;
    height: 2.51rem;
    object-fit: cover;
    position: absolute;
    top: -0.25rem;
    left: 0.89rem;
}

.homePageRunPowerRestText {
    width: 100%;
    font-size: 0.67rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Regular;
    font-weight: 400;
    text-align: center;
    color: #6f8fea;
    line-height: 0.72rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.homePageRanking {
    width: 100%;
    box-sizing: border-box;
    margin-top: 1.024rem;
    padding: 0 1.59rem;
}

.homePageRankingNum {
    width: 100%;
    height: 7.95rem;
    box-sizing: border-box;
    margin-top: 0.92rem;
    padding: 0 1.67rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.homePageRankingNumOne {
    width: 7.69rem;
    height: 7.95rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.44rem;
    box-shadow: 0.05rem 0.25rem 0.95rem 0.26rem rgba(111, 143, 234, 0.12);
    position: relative;
}

.homePageRankingNumTitle {
    font-size: 0.72rem;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    text-align: left;
    color: #2f2f51;
    line-height: 1.03rem;
    position: absolute;
    top: 0.87rem;
    left: 50%;
    transform: translateX(-50%);
}

.homePageRankingNumBg {
    width: 4.62rem;
    height: 4.62rem;
    opacity: 0.76;
    border-radius: 50%;
    position: absolute;
    top: 2rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.homePageRankingNumBgColor {
    background: linear-gradient(146.9083deg, #feb497 0%, #f96c7c 100%);
}

.homePageRankingNumBgColor2 {
    background: linear-gradient(135deg, #ccd7ff 0%, #8fa8ff 100%);
}

.homePageRankingNumBgText {
    font-size: 1.54rem;
    font-family: PangMenZhengDao, PangMenZhengDao-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 1.85rem;
    letter-spacing: 0.01rem;
}

.homePageRankingNumBgTextSmall {
    font-size: 1rem;
}

.homePageRankingNumBgText2 {
    font-size: 0.72rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    line-height: 0.92rem;
    letter-spacing: 0.01rem;
    padding-top: 0.45rem;
}

.homePageRankingNumBgText2Small {
    padding-top: 0;
}

.homePageAddVip {
    width: 100%;
    box-sizing: border-box;
    margin-top: 1.49rem;
}

.homePageAddVipTop {
    width: 19.28rem;
    height: 9.23rem;
    background-image: url('../assets/images/newHome/VipBg.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    margin: 0 auto;
    position: relative;
}

.homePageAddVipImg {
    width: 6.5rem;
    /* height: 7.18rem; */
    -o-object-fit: contain;
    object-fit: contain;
    position: absolute;
    top: 0.7rem;
    left: 2rem;
}

.homePageAddVipText {
    font-size: 0.87rem;
    font-family: HelveticaNeueLT, HelveticaNeueLT-LightExt;
    font-weight: normal;
    text-align: left;
    color: #474ad9;
    line-height: 1.23rem;
    position: absolute;
    top: 1.95rem;
    left: 7.9rem;
}

.homePageAddVipText2 {
    font-size: 0.56rem;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi-Regular;
    font-weight: 400;
    text-align: left;
    color: #9797a8;
    line-height: 0.82rem;
    position: absolute;
    top: 3.4rem;
    left: 7.9rem;
}

.homePageAddVipAddButton {
    width: 4rem;
    height: 4rem;
    position: absolute;
    top: 5.6rem;
    left: 51.2%;
    transform: translateX(-50%);
    background-image: url('../assets/images/newHome/addButton.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
}

/deep/ .unique-custom-date-style .van-calendar-day__top {
    color: red;
    font-weight: bold;
}

.homePageAddBottom {
    width: 100%;
    box-sizing: border-box;
    padding-top: 0.44rem;
    padding-bottom: 2.09rem;
    display: flex;
    justify-content: center;
}

.homePageAddBottomImg {
    width: 11.03rem;
}

.homeMaskLayer {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .5);
}

.homeMaskLayerIcon {
    width: 8rem;
    height: 8rem;
    position: absolute;
    top: 10rem;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.8;
}

/* 定义翻转的元素样式 */
.flip-element {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 定义翻转动画 */
@keyframes flip {
    0% {
        transform: translateX(-50%) rotateX(0deg);
    }

    50% {
        transform: translateX(-50%) rotateX(40deg);
    }

    100% {
        transform: translateX(-50%) rotateX(0deg);
    }
}

/* 应用动画的样式类 */
.flipping {
    animation: flip 1s ease-in-out;
    animation-iteration-count: 3;
    /* 动画反转 3 次 */
}
</style>